// Admin API client: Bearer admin session (12 h); 401 → login screen. Errors keep the server's
// machine reason + details (for the human error card) and the request id ("Подробнее").
const API_URL = import.meta.env.VITE_API_URL.replace(/\/+$/, '');
const TOKEN_KEY = 'fonus-admin-token';

export const tokenStore = {
  get: (): string | null => {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set: (t: string | null) => {
    try {
      if (t) localStorage.setItem(TOKEN_KEY, t);
      else localStorage.removeItem(TOKEN_KEY);
    } catch {
      // private mode
    }
    window.dispatchEvent(new Event('fonus-admin-auth'));
  },
};

export class ApiFailure extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly reason: string | null,
    readonly detail: Record<string, unknown>,
    readonly requestId: string | null,
  ) {
    super(message);
  }
}

export async function api<T>(
  path: string,
  init: { method?: string; body?: unknown } = {},
): Promise<T> {
  const token = tokenStore.get();
  let res: Response;
  try {
    res = await fetch(`${API_URL}${path}`, {
      method: init.method ?? 'GET',
      headers: {
        ...(init.body === undefined ? {} : { 'content-type': 'application/json' }),
        ...(token ? { authorization: `Bearer ${token}` } : {}),
      },
      ...(init.body === undefined ? {} : { body: JSON.stringify(init.body) }),
    });
  } catch {
    throw new ApiFailure(0, 'Нет связи с сервером', 'NETWORK', {}, null);
  }
  const body = (await res.json().catch(() => ({}))) as {
    message?: string;
    error?: string;
    reason?: string;
    detail?: Record<string, unknown>;
    requestId?: string;
  };
  if (res.status === 401 && token) tokenStore.set(null);
  if (!res.ok) {
    throw new ApiFailure(
      res.status,
      body.message ?? body.error ?? `HTTP ${String(res.status)}`,
      body.reason ?? body.error ?? null,
      body.detail ?? {},
      body.requestId ?? res.headers.get('x-request-id'),
    );
  }
  return body as T;
}
